package team.platforma.materialextension.sample_screens

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.Checkbox
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import materialextension.composeapp.generated.resources.Res
import materialextension.composeapp.generated.resources.right_arrow
import org.jetbrains.compose.resources.painterResource
import team.platforma.multiplatform_material_extension.ui.buttons.ExpandStrategy
import team.platforma.multiplatform_material_extension.ui.buttons.ExtraElevatedButton
import team.platforma.multiplatform_material_extension.ui.buttons.ExtraFAB
import team.platforma.multiplatform_material_extension.ui.buttons.ExtraFilledButton
import team.platforma.multiplatform_material_extension.ui.buttons.ExtraOutlinedButton
import team.platforma.multiplatform_material_extension.ui.buttons.ExtraTextButton
import team.platforma.multiplatform_material_extension.ui.buttons.ExtraTonalButton
import team.platforma.multiplatform_material_extension.ui.buttons.IconGravity
import team.platforma.multiplatform_material_extension.ui.buttons.utils.ButtonIcon
import team.platforma.multiplatform_material_extension.ui.buttons.utils.ButtonText
import team.platforma.multiplatform_material_extension.ui.buttons.utils.TextGravity
import team.platforma.multiplatform_material_extension.ui.core.InputFieldProperties
import team.platforma.multiplatform_material_extension.ui.drop_down.DropdownField
import team.platforma.multiplatform_material_extension.ui.drop_down.model.ListItem

@Composable
fun ButtonsSample() {

    var expanded by remember { mutableStateOf(false) }

    var enabled by remember { mutableStateOf(true) }

    var matchParent by remember { mutableStateOf(false) }

    val modifier = remember { Modifier }


    val icon = ButtonIcon(
        painter = painterResource(Res.drawable.right_arrow),
        iconGravity = IconGravity.End,
        attachText = false
    )
    var buttonIcon by remember { mutableStateOf<ButtonIcon?>(icon) }

    var textGravity by remember { mutableStateOf<ListItem>(ListItem(id = 0, title = "Center")) }

    var iconGravity by remember { mutableStateOf<ListItem>(ListItem(id = 2, title = "End")) }

    var buttonGravity by remember { mutableStateOf<ListItem>(ListItem(id = 2, title = "End")) }

    LaunchedEffect(iconGravity) {
        when (iconGravity.title) {
            "Start" -> {
                buttonIcon =
                    icon.copy(iconGravity = setIconGravity(iconGravity), attachText = false)
            }

            "End" -> {
                buttonIcon =
                    icon.copy(iconGravity = setIconGravity(iconGravity), attachText = false)
            }

            "StartAttached" -> {
                buttonIcon = icon.copy(iconGravity = setIconGravity(iconGravity), attachText = true)
            }

            "EndAttached" -> {
                buttonIcon = icon.copy(iconGravity = setIconGravity(iconGravity), attachText = true)
            }
        }

    }

    when (matchParent) {
        true -> modifier.fillMaxWidth()
        false -> {}
    }

    LazyColumn(
        modifier = Modifier.fillMaxWidth(),
        contentPadding = PaddingValues(16.dp)
    ) {

        item {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = when (buttonGravity.title) {
                    "Center" -> Alignment.CenterHorizontally
                    "Start" -> Alignment.Start
                    "End" -> Alignment.End
                    else -> {
                        Alignment.CenterHorizontally
                    }
                }
            ) {
                ExtraFAB(
                    expanded = expanded,
                    areaModifier = Modifier,
                    expandStrategy = if (matchParent) ExpandStrategy.MaxWidth else ExpandStrategy.WrapContent,
                    iconGravity = setIconGravity(iconGravity),
                    text = {
                        Text(
                            text = "01:39",
                        )
                    },
                    icon = {
                        Icon(
                            painter = painterResource(Res.drawable.right_arrow),
                            contentDescription = null
                        )
                    },
                    enabled = enabled,
                    onClick = {

                    },
                )

                Spacer(modifier = Modifier.height(8.dp))



                ExtraFilledButton(
                    modifier = matchParent(matchParent),
                    enabled = enabled,
                    onClick = {},
                    buttonText = ButtonText(
                        text = "ExtraFilledButton", gravity = setTextGravity(textGravity)
                    ),
                    buttonIcon = buttonIcon
                )
                Spacer(modifier = Modifier.height(8.dp))
                ExtraTonalButton(
                    modifier = matchParent(matchParent),
                    enabled = enabled,
                    onClick = {},
                    buttonText = ButtonText(
                        text = "ExtraTonalButton", gravity = setTextGravity(textGravity)
                    ),
                    buttonIcon = buttonIcon
                )
                Spacer(modifier = Modifier.height(8.dp))

                ExtraOutlinedButton(
                    modifier = matchParent(matchParent),
                    enabled = enabled,
                    onClick = {},
                    buttonText = ButtonText(
                        text = "ExtraOutlinedButton", gravity = setTextGravity(textGravity)
                    ),
                    buttonIcon = buttonIcon
                )
                Spacer(modifier = Modifier.height(8.dp))

                ExtraElevatedButton(
                    modifier = matchParent(matchParent),
                    enabled = enabled,
                    onClick = {},
                    buttonText = ButtonText(
                        text = "ExtraElevatedButton", gravity = setTextGravity(textGravity)
                    ),
                    buttonIcon = buttonIcon
                )
                Spacer(modifier = Modifier.height(8.dp))

                ExtraTextButton(
                    modifier = matchParent(matchParent),
                    enabled = enabled,
                    onClick = {},
                    buttonText = ButtonText(
                        text = "ExtraTextButton", gravity = setTextGravity(textGravity)
                    ),
                    buttonIcon = buttonIcon
                )
                Spacer(modifier = Modifier.height(8.dp))

                Row(
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Checkbox(checked = expanded, onCheckedChange = {
                        expanded = it
                    })
                    Spacer(modifier = Modifier.width(4.dp))
                    Text(
                        text = if (expanded) "FAB Expanded" else "FAB shrink"
                    )
                }

                Spacer(modifier = Modifier.height(8.dp))

                Row(
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Checkbox(checked = enabled, onCheckedChange = {
                        enabled = it
                    })
                    Spacer(modifier = Modifier.width(4.dp))
                    Text(
                        text = if (enabled) "Enabled" else "Disabled"
                    )
                }

                Spacer(modifier = Modifier.height(8.dp))

                Row(
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Checkbox(checked = matchParent, onCheckedChange = {
                        matchParent = it
                    })
                    Spacer(modifier = Modifier.width(4.dp))
                    Text(
                        text = if (matchParent) "Match parent" else "Wrap content"
                    )
                }

                Spacer(modifier = Modifier.height(8.dp))

                DropdownField.create(
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    list = listOf(
                        ListItem(id = 0, title = "Center"),
                        ListItem(id = 1, "Start"),
                        ListItem(id = 2, "End")
                    ),
                    initializeItem = textGravity,
                    onItemSet = { selectTextGravity ->
                        textGravity = selectTextGravity
                    }
                ).Outline(InputFieldProperties().simpleLabel("Text gravity"))

                Spacer(modifier = Modifier.height(8.dp))

                DropdownField.create(
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    list = listOf(
                        ListItem(id = 0, title = "Center"),
                        ListItem(id = 1, "Start"),
                        ListItem(id = 2, "End")
                    ),
                    initializeItem = buttonGravity,
                    onItemSet = { selectButtonGravity ->
                        buttonGravity = selectButtonGravity
                    }
                ).Outline(InputFieldProperties().simpleLabel("Button gravity"))

                DropdownField.create(
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    list = listOf(
                        ListItem(id = 1, "Start"),
                        ListItem(id = 2, "End"),
                        ListItem(id = 3, "StartAttached"),
                        ListItem(id = 4, "EndAttached")
                    ),
                    initializeItem = iconGravity,
                    onItemSet = { selectIconGravity ->
                        iconGravity = selectIconGravity
                    }
                ).Outline(InputFieldProperties().simpleLabel("Icon gravity"))

                Row(
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Checkbox(checked = buttonIcon != null, onCheckedChange = {
                        buttonIcon = if (it) {
                            icon
                        } else {
                            null
                        }
                    })
                    Spacer(modifier = Modifier.width(4.dp))
                    Text(
                        text = if (buttonIcon != null) "With Icon" else "No icon"
                    )
                }

            }

        }

    }


}

private fun setIconGravity(iconGravity: ListItem) =
    when (iconGravity.title) {
        "Start" -> IconGravity.Start
        "End" -> IconGravity.End
        "StartAttached" -> IconGravity.Start
        "EndAttached" -> IconGravity.End
        else -> IconGravity.End
    }

private fun setTextGravity(textGravity: ListItem) =
    when (textGravity.title) {
        "Center" -> TextGravity.Center
        "Start" -> TextGravity.Start
        "End" -> TextGravity.End
        else -> TextGravity.Center
    }

fun matchParent(matchParent: Boolean): Modifier {
    return if (matchParent) {
        Modifier.fillMaxWidth()
    } else {
        Modifier
    }
}